<template>
  <div class="TeamMemberItem">
    <div class="left">
      <div class="avatar">
        <van-image class="img" :src="item.avatar" fit="cover" round />
      </div>
      <div class="info">
        <div class="name text-ellipsis">{{item.name}}</div>
      </div>
    </div>
    <div class="tags">
      <div class="tag tag1" v-if="item.roleType === 1"><span>负责人</span></div>
      <div class="tag tag2" v-if="item.roleType === 2"><span>管理员</span></div>
      <div class="tag tag3" v-if="item.roleType === 3"><span>普通成员</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamMemberItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="less" scoped>
.TeamMemberItem {
  margin: 0 auto 20px;
  padding: 30px 28px;
  width: 694px;
  height: 134px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    .avatar {
      width: 74px;
      height: 74px;
      margin-right: 20px;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 66px;
        height: 66px;
      }
    }
    .info {
      flex: 1;
      width: 0;
      .name {
        font-size: 28px;
        color: #333333;
      }
    }
  }
  .tags {
    margin-left: 20px;
    display: flex;
    align-items: center;
    .tag {
      min-width: 132px;
      height: 50px;
      border-radius: 40px;
      font-size: 18px;
      font-size: 24px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;
      padding-right: 10px;
    }
    .tag1 {
      background-color: #FF485D;
    }
    .tag2 {
      background-color: #5BA7FF;
    }
    .tag3 {
      background-color: #999AAA;
    }
    .icon{
      width: 40px;
      height: 40px;
      &.icon_01{
        margin-left: 20px;
        background-image: url('~@/assets/images/icon_operate_03.png');
      }
    }
  }
}
</style>